// Feature detection utilities
export const browserSupport = {
  // Check if the browser supports IntersectionObserver
  hasIntersectionObserver: () => 
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window,

  // Check if the browser supports the Geolocation API
  hasGeolocation: () => 
    'geolocation' in navigator,

  // Check if the browser supports localStorage
  hasLocalStorage: () => {
    try {
      localStorage.setItem('test', 'test');
      localStorage.removeItem('test');
      return true;
    } catch (e) {
      return false;
    }
  },

  // Check if the browser supports WebP
  hasWebP: async () => {
    const webP = new Image();
    webP.src = 'data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==';
    return new Promise((resolve) => {
      webP.onload = webP.onerror = () => {
        resolve(webP.height === 1);
      };
    });
  },

  // Check if the browser supports the Payment Request API
  hasPaymentRequest: () => 
    'PaymentRequest' in window,

  // Check if the browser supports the Crypto API
  hasCrypto: () => 
    'crypto' in window,

  // Load polyfills based on feature detection
  loadPolyfills: async () => {
    const polyfills = [];
    const loaded = new Set();

    if (!browserSupport.hasIntersectionObserver()) {
      if (!loaded.has('intersection-observer')) {
        polyfills.push(import('intersection-observer'));
        loaded.add('intersection-observer');
      }
    }

    if (!window.fetch) {
      if (!loaded.has('whatwg-fetch')) {
        polyfills.push(import('whatwg-fetch'));
        loaded.add('whatwg-fetch');
      }
    }

    if (!window.Promise) {
      if (!loaded.has('promise-polyfill')) {
        polyfills.push(import('promise-polyfill'));
        loaded.add('promise-polyfill');
      }
    }

    try {
      await Promise.all(polyfills);
      return true;
    } catch (error) {
      console.error('Error loading polyfills:', error);
      return false;
    }
  }
};